import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

interface VerificationRequiredProps {
  title?: string;
  message?: string;
  buttonText?: string;
  redirectPath?: string;
  onVerifyClick?: () => void;
  showVerifyButton?: boolean;
}

const VerificationRequired: FC<VerificationRequiredProps> = ({
  title = "Email Required",
  message = "Please set up your email address in Account Settings before accessing this page.",
  buttonText = "Go to Account Settings",
  redirectPath = "/mysettings",
  onVerifyClick,
  showVerifyButton = true,
}) => {
  return (
    <div className="row">
      <div className="col-lg-12 mb-4 mb-lg-0">
        <div className="bs-card p-5">
          <h4 className="mb-4 fw-medium fs-5">{title}</h4>
          <p className="mb-4 text-muted">{message}</p>
          <div className="d-flex gap-3">
            {showVerifyButton && (
              <Button variant="primary" onClick={onVerifyClick}>
                Verify Email
              </Button>
            )}
            <Link to={redirectPath} className="btn btn-primary">
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationRequired;
